// http://3.15.93.231/3plapi/user/list

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class UsersApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

   //LIST
   public getUsers(payload: any): Observable<any> {
    return this.http.post(`${this.url}user/list`, payload);
   }

   //SAVE/EDIT
   public editUser(payload: any): Observable<any> {
    return this.http.post(`${this.url}user/create`, payload);
   }

   //DELETE
   public deleteUser(payload: any): Observable<any> {
    return this.http.post(`${this.url}user/delete`, payload);
   }

   //ORG LIST
   public getOrg(): Observable<any> {
      return this.http.get(`${this.url}get/threepl`);
   }

   //RESET PASSWORD
   public resetPassword(payload: any): Observable<any> {
      return this.http.post(`${this.url}user/forgot/password`, payload);
   }

   //GET LOB LIST
   public getLOBs(): Observable<any> {
      return this.http.get(`${this.url}lob/getLobs`)
   }
}